import React, { Fragment, FunctionComponent } from "react";
import HeaderProps from "./HeaderProps.interface";

import Header1 from "./blocks/Header1/Header1";
import Header2 from "./blocks/Header2/Header2";
import Header3 from "./blocks/Header3/Header3";
import Header4 from "./blocks/Header4/Header4";
import Header5 from "./blocks/Header5/Header5";
import Header6 from "./blocks/Header6/Header6";
import Header7 from "./blocks/Header7/Header7";

const HEADER_TYPES: { [key: string]: any } = {
    "blockHeader1": Header1,
    "blockHeader2": Header2,
    "blockHeader3": Header3,
    "blockHeader4": Header4,
    "blockHeader5": Header5,
    "blockHeader6": Header6,
    "blockHeader7": Header7,
};

const Header: FunctionComponent<HeaderProps> = (props) => {
    const DynamicHeader = HEADER_TYPES[props.contentType];

    return <Fragment>{DynamicHeader && props.settings ? <DynamicHeader {...props.settings} /> : null}</Fragment>;
};

export default Header;
